<template>
  <div class="toast-mask" v-show="isShow">
    <div class="toast-dialog-icon weui-animate-fade-in" v-if="type==='icon'">
      <i class="toast-icon" :class="iconStatus"></i>
      <div class="toast-content" v-html="message" :class="{noradius:!round}"></div>
    </div>

    <div class="toast-dialog-normal weui-animate-fade-in" :class="position" v-if="type==='normal'">
      <div class="toast-content" v-html="message" :class="{noradius:!round}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "toast",
  data() {
    return {
      isShow: true
    };
  },
  props: {
    type: {
      type: String,
      default: "normal"
    },
    status: {
      type: String,
      default: "success"
    },
    message: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "normal"
    },
    duration: {
      type: Number,
      default: 3000
    },
    round: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    iconStatus() {
      if (this.status === "success") {
        return "icon-success";
      } else if (this.status === "fail") {
        return "icon-fail";
      }
    }
  },
  methods: {}
};
</script>
<style scoped lang="scss">
.toast-mask {
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}

.toast-dialog-icon {
  position: fixed;
  z-index: 5000;
  top: 4rem;
  right: 0px;
  left: 0px;
  max-width: 3.6rem;
  max-height: 3.6rem;
  width: auto;
  margin: 0 auto;
  padding: 0.5rem 0.2rem;
  box-sizing: border-box;
  background: rgba(27, 27, 27, 0.8);
  text-align: center;
  border-radius: 0.1rem;
  font-size: 0.32rem;
  color: #ffffff;

  // .toast-icon{
  //     width:1rem;
  //     height: 1rem;
  //     margin:0 auto 0.3rem;
  //     display: block;
  //     &.icon-success{
  //       background:url(../../assets/img/icon/success_1.png) no-repeat;
  //       background-size:cover;
  //     }
  //     &.icon-fail{
  //       background:url(../../assets/img/icon/fail_1.png) no-repeat;
  //       background-size:cover;
  //     }

  // }
  .toast-content {
    margin: 0;
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
    span {
      font-size: 0.24rem;
      display: inline-block;
      margin-top: 0.2rem;
      color: #999999;
    }
  }
}

.toast-dialog-normal {
  position: fixed;
  left: 0px;
  right: 0px;
  top: 40%;
  z-index: 1000;
  max-width: 6rem;
  margin: auto;
  text-align: center;
  -webkit-transition: opacity 0.3s linear;
  transition: opacity 0.3s linear;
  font-size: 0.28rem;
  background: none;
  box-sizing: border-box;
  color: #fff;
  &.top {
    top: 1.4rem;
  }
  &.bottom {
    top: auto;
    bottom: 1.4rem;
  }
  .toast-content {
    margin: 0;
    display: inline-block;
    /*padding: 0.1rem 0.5rem;*/
    padding: 0.7rem 0.5rem;
    font-size: 0.36rem;
    text-align: center;
    letter-spacing: 0.08rem;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
  }
  .noradius {
    border-radius: 0 !important;
  }
}

.mint-toast-pop-enter,
.mint-toast-pop-leave-active {
  opacity: 0;
}
.mint-toast-pop {
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}
</style>



// WEBPACK FOOTER //
// src/components/JmmToast/toast.vue